module.exports = {"QUOTE":{"BTN_ADD_TO_GARAGE":"Ajouter au garage","BTN_APPLY_QUOTE_CHANGES":"Appliquer les changements"}}


//////////////////
// WEBPACK FOOTER
// ../widget-commons-vehicle/src/Quote/i18n/fr.json
// module id = ../widget-commons-vehicle/src/Quote/i18n/fr.json
// module chunks = widget-6.25.3